var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "notSatisfiedBoxCard" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showHeader,
              expression: "showHeader",
            },
          ],
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
          },
        },
        [
          _c(
            "span",
            { staticStyle: { "font-size": "18px", "font-weight": "bold" } },
            [_vm._v("意見調查滿意度（不滿意的旅客）")]
          ),
          _c(
            "router-link",
            { attrs: { to: "/agency/agencyOpinionSurvey/index" } },
            [
              _c("el-button", {
                attrs: {
                  size: "mini",
                  icon: "el-icon-arrow-right",
                  circle: "",
                  text: "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            size: "mini",
            stripe: "",
            data: _vm.statisticsData,
            "max-height": _vm.dynamicMaxHeight,
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "userName", label: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", { staticStyle: { color: "#333" } }, [
                      _vm._v(_vm._s(row.userName)),
                    ]),
                    _c("br"),
                    _c("span", { staticStyle: { color: "#818181" } }, [
                      _vm._v(_vm._s(row.title)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "satisfactionPoint",
              label: "",
              width: "80",
              align: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          color: "red",
                          "font-weight": "500",
                          "font-size": "16px",
                        },
                      },
                      [_vm._v(" " + _vm._s(row.satisfactionPoint) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("not-satisfied-detail-dialog", {
                      attrs: {
                        uid: row.userID,
                        travelID: row.travelID,
                        qid: row.qid,
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      false
        ? _c(
            "el-card",
            {
              staticClass: "box-card-component",
              staticStyle: { "margin-top": "8px" },
              attrs: { shadow: "none", loading: _vm.listLoading },
            },
            [
              _vm.statisticsData && _vm.statisticsData.length > 0
                ? _c(
                    "div",
                    {
                      staticStyle: { "margin-bottom": "4px" },
                      style: {
                        height: _vm.dynamicMaxHeight,
                        overflowY: "auto",
                      },
                    },
                    _vm._l(_vm.statisticsData, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "progress-item",
                          staticStyle: {
                            padding: "6px 0",
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  gap: "0 12px",
                                  "line-height": "24px",
                                  "letter-spacing": "0.1em",
                                },
                              },
                              [
                                _c("strong", [_vm._v(_vm._s(item.userName))]),
                                false
                                  ? _c("el-rate", {
                                      attrs: {
                                        value: item.satisfactionPoint,
                                        disabled: "",
                                        "show-score": "",
                                        colors: [
                                          "#E16D6D",
                                          "#F7BA2A",
                                          "#F7BA2A",
                                        ],
                                        "text-color": "#E16D6D",
                                        "score-template": "{value}",
                                      },
                                    })
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      gap: "0 4px",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#e16d6d",
                                          "font-weight": "500",
                                        },
                                      },
                                      [_vm._v(_vm._s(item.satisfactionPoint))]
                                    ),
                                    _c("svg-icon", {
                                      staticStyle: {
                                        color: "#e16d6d",
                                        "font-size": "10px",
                                      },
                                      attrs: { "icon-class": "star" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  "line-height": "24px",
                                  "letter-spacing": "0.1em",
                                },
                              },
                              [_vm._v(" 團號：" + _vm._s(item.title) + " ")]
                            ),
                          ]),
                          _c("not-satisfied-detail-dialog", {
                            attrs: {
                              uid: item.userID,
                              travelID: item.travelID,
                              qid: item.qid,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }